import React, { useState, useEffect } from 'react';
import { lpvistastaker ,lpvistalock,lpvistaunlock,claimRewardsLOCK,getStatsLOCK,lock, getBalanceAndSymbol} from '../../functions/dexfunctions'
import { popupManager } from '../common/PopupManager';
import { useParams } from "react-router-dom";
import { getPairAddressForBondedTokenForGraph } from '../../functions/factoryFunctions';

export default function Hardlock({signer}) {
  const [activeTab, setActiveTab] = useState('vista');

  // State variables
  const [selectedToken, setSelectedToken] = useState(null);
  const [pairAddress, setPairAddress] = useState('');
  const [tokenAmount, setTokenAmount] = useState('');
  const [lockedAmountVista, setLockedAmountVista] = useState(0);
  const [timeLeftVista, setTimeLeftVista] = useState('');
  const [rewardsStatsVista, setrewardsStatsVista] = useState([]); // [currentRewards, allTimeRewards, currentPool]
  const [hasRewards, setHasRewards] = useState(false);
  const [stakedVistaLP, setstakedVistaLP] = useState(null); 
  const [stakedVistaLPTime, setstakedVistaLPTime] = useState(null); 
  const [vistaLPBalance, setvistaLPBalance] = useState(null)
  const [pairLPBalance, setpairLPBalance] = useState(null)

  //HARDLOCK OTHER TOKENS
  const [rewardsStats, setrewardsStats] = useState([]); // [currentRewards, allTimeRewards, currentPool]
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [featuredTokens, setfeaturedTokens] = useState([]);
  const [tokenLockInfo, settokenLockInfo] = useState([]);
  const [othertokenAmount, setothertokenAmount] = useState('');
  const {chain,tokenAddress } = useParams();

  // Transaction path for Hardlock - always the same
  const getTransactionPath = () => {
    return [
      "1. Approve (Once)",
      "2. Hardlock"
    ];
  };

  const transactionPath = getTransactionPath();

  const ethAddress = "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2";

  const handleAddressInput = async () => {
    if (pairAddress) {

      setSelectedToken({ name:'Pair Address: '+ pairAddress.slice(0,6)+"..."+ pairAddress.slice(-6) });
      setIsPopupOpen(false);
      fetchRewardsForPair(pairAddress);
    }
  };
  const fetchTokens = async () => {
    if(chain !== "ethereum"){
      setActiveTab("hardlock")
    }
    const response = await fetch('https://qwertz.ink/vistadex/tokens?page=1&sort=fdv:DESC&chain='+chain);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    const filteredData = data.data.filter(
      (item) => item.address.toLowerCase() !== "0xc9bca88b04581699fab5aa276ccaff7df957cbbf"
    );
    setfeaturedTokens(filteredData)
    

  }
  const fetchBalancesVista = async () => {
    const vistaLp = await getBalanceAndSymbol("0xfdd05552F1377aA488AFed744c8024358AF02041",ethAddress,signer)
    setvistaLPBalance(vistaLp)
  }
  const fetchBalancesPair = async (pair) => {
    const pairLp = await getBalanceAndSymbol(pair,ethAddress,signer, true)
    //console.log(pairLp)
    setpairLPBalance(pairLp)
  }

  const handleTokenSelect = async (token) => {
    setSelectedToken(token);
    let paircalc = await getPairAddressForBondedTokenForGraph(token.address,ethAddress,chain)
    setPairAddress(paircalc);
    setIsPopupOpen(false);
    fetchBalancesPair(paircalc);

    // Fetch rewards data for the selected token
    fetchRewardsForPair(paircalc);
  };

  useEffect(() => {
      fetchTokens()
    
  }, []);
  
  useEffect(() => {

    fetchVistaLock(signer)
    fetchRewardsForVista(signer)
    fetchBalancesVista()
  }, [chain,signer]);

  function chainParamToChainId(chainParam) {
    switch (chainParam) {
      case "ethereum":
        return 1;
      // add more if needed
      default:
        return null; // or 1 as a default
    }
  }

  useEffect(() => {
    if (!signer) return;

    const requiredChainId = chainParamToChainId(chain);

    // If we don't have a mapping, you might handle that differently
    if (!requiredChainId) return;

    (async () => {
      try {
        // Ethers.js v6 returns an object with .chainId
        const network = await signer.provider.getNetwork();
        const currentChainId = Number(network.chainId);

        if (currentChainId !== requiredChainId) {
          popupManager.addPopup({
            id: Date.now(),
            type: "error",
            message: "Please connect your wallet to the selected network!",
            duration: 6000,
          });
        }
      } catch (err) {
        console.error("Error checking network:", err);
      }
    })();
  }, [signer, chain]);

  const fetchVistaLock = async (signerInstance) => {
    try{
      const vistaLockStats = await lpvistastaker(signer)
      //console.log(vistaLockStats)
      settokenLockInfo(vistaLockStats)

    }catch(e){
      //console.log(e)
    }
  }

  const fetchRewardsForVista = async (signerInstance) => {
    try{
      //console.log(signer,chain)
      const response = await getStatsLOCK('0xfdd05552F1377aA488AFed744c8024358AF02041',signer,chain)
      //console.log(response)
      setrewardsStatsVista(response)
    }catch(e){
      console.log(e)
    }
  }

  const fetchRewardsForPair = async (pairAddress) => {
    try{
      
      setPairAddress(pairAddress)
      const response = await getStatsLOCK(pairAddress,signer,chain)
      setrewardsStats(response)
    }catch(e){
      //console.log(e)
    }
  }

  const handleLockToken = async () => {

    let id = Date.now();
    try{
      const network = await signer.provider.getNetwork();
      const chainId = Number(network.chainId);
      const requiredChainId = chainParamToChainId(chain);
      //console.log(requiredChainId,chainId)
      if (chainId !== requiredChainId) {
        popupManager.addPopup({
          id: Date.now(),
          type: "error",
          message: "Please connect your wallet to the selected network!",
          duration: 6000,
        });
        return;
      }
      popupManager.addPopup({
        id: id,
        type: "message",
        message: "Hardlocking "+othertokenAmount +" of "+pairAddress,
      });
      const resp = await lock(pairAddress,othertokenAmount,signer,selectedToken.address,chain)
      popupManager.removePopup(id);
      let successful_id = Date.now();

      popupManager.addPopup({
        id: successful_id,
        type: "success",
        message:
          "Transaction Sent!",
      });
    }catch(e){
      console.log(e)
      popupManager.removePopup(id);
      popupManager.addPopup({
        id: Date.now(),
        type: "error",
        message: e.toString(),
        duration: 6000,
      });
      //console.log(e)
    }
  }

  const handleLockVista = async () => {
    let id = Date.now();
    try{
      const network = await signer.provider.getNetwork();
      const chainId = Number(network.chainId);
      let chainIdURL = 1;

      if (chainId !== chainIdURL) {
        popupManager.addPopup({
          id: Date.now(),
          type: "error",
          message: "Please connect your wallet to the selected network!",
          duration: 6000,
        });
        return;
      }
      popupManager.addPopup({
        id: id,
        type: "message",
        message: "Locking "+ tokenAmount + " VISTA-LP",
      });
      const response = await lpvistalock(tokenAmount,signer)
      
      popupManager.removePopup(id);
      let successful_id = Date.now();

      popupManager.addPopup({
        id: successful_id,
        type: "success",
        message:
          "Transaction Sent!",
      });
      setTokenAmount('');

    }catch(e){
      popupManager.removePopup(id);
      popupManager.addPopup({
        id: Date.now(),
        type: "error",
        message: e.toString(),
        duration: 6000,
      });
      //console.log(e)
    }
  };

  const handleUnlockVista = async() => {
    let id = Date.now();
    try {
      const network = await signer.provider.getNetwork();
      const chainId = Number(network.chainId);
      let chainIdURL = 1;
      if (chainId !== chainIdURL) {
        popupManager.addPopup({
          id: Date.now(),
          type: "error",
          message: "Please connect your wallet to the selected network!",
          duration: 6000,
        });
        return;
      }
      popupManager.addPopup({
        id: id,
        type: "message",
        message: "Unlocking Vista-LP for " + tokenAmount,
      });
      const resp = await lpvistaunlock(tokenAmount,signer)

      popupManager.removePopup(id);
      let successful_id = Date.now();

      popupManager.addPopup({
        id: successful_id,
        type: "success",
        message:
          "Transaction Sent!",
      });

      //console.log(resp)
    } catch (error) {
      popupManager.removePopup(id);
      popupManager.addPopup({
        id: Date.now(),
        type: "error",
        message: error.toString(),
        duration: 6000,
      });
      //console.log(error)
    }
  };

  const handleClaimRewards = async (pairAddress) => {
    let id = Date.now();
    try {
      const network = await signer.provider.getNetwork();
      const chainId = Number(network.chainId);
      const requiredChainId = chainParamToChainId(chain);

      if (chainId !== requiredChainId) {
        popupManager.addPopup({
          id: Date.now(),
          type: "error",
          message: "Please connect your wallet to the selected network!",
          duration: 6000,
        });
        return;
      }
      popupManager.addPopup({
        id: id,
        type: "message",
        message: "Claiming Rewards for " + pairAddress,
      });
      const response = await claimRewardsLOCK(pairAddress,signer)
      
      popupManager.removePopup(id);
      let successful_id = Date.now();

      popupManager.addPopup({
        id: successful_id,
        type: "success",
        message:
          "Transaction Sent",
      });
      //console.log(response)
    } catch (e) {
      popupManager.removePopup(id);
      popupManager.addPopup({
        id: Date.now(),
        type: "error",
        message: e.toString(),
        duration: 6000,
      });
      //console.log(e)
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'vista':
        return (
          <div>
            

            {/* Input for Token Amount */}
            <div className="mb-4">
              <label htmlFor="tokenAmount" className="block text-white text-start mb-2">
                Enter Amount of VISTA LP tokens
              </label>
              <input
                type="number"
                id="tokenAmount"
                value={tokenAmount}
                onWheel={e => e.target.blur()}  
                onChange={(e) => setTokenAmount(e.target.value)}
                placeholder="Token Amount"
                className="w-full px-4 py-3 border-t border-b text-[15px]  border-white/15 text-gray-300 rounded-md bg-transparent focus:outline-none"
                min="0"
              />
            </div>

            {/* Labels */}
            <div className="mb-4 text-gray-300 space-y-2">
              {vistaLPBalance >0 &&
              <p className="flex justify-between">
                <p>Vista LP Balance:</p> <span>{vistaLPBalance}</span>
              </p>              
              }

              <p className="flex justify-between">
                <p>Locked Amount:</p> <span>{tokenLockInfo.amount}</span>
              </p>
              <p className="flex justify-between">
                <p>Lock Time:</p> <span>14 days</span>
              </p>
              <p className="flex justify-between">
                <p>Time Left:</p> <span>{tokenLockInfo.timeLeftFormatted}</span>
              </p>

              {rewardsStatsVista && (
                <>
                  <p className="flex justify-between">
                    <p>Your Rewards:</p> <span>${rewardsStatsVista[0]}</span>
                  </p>
                  <p className="flex justify-between">
                    <p>Yearly Rewards:</p> <span>${rewardsStatsVista[1]}</span>
                  </p>
                </>
              )}
            </div>


            {/* Warning */}
            <div className="mb-4 p-4 bg-white/10 border-l-4 border-white-500 text-white-700">
              <p>
              Please claim any rewards before staking/unstaking, or the rewards will be lost.
              </p>
            </div>

            {/* Transaction Path Indicator */}
            {signer && (
              <div className="mt-4 mb-2 p-3 bg-white/5 border border-white/10 rounded-lg">
                <div className="flex items-center gap-2 mb-2">
                  <svg className="w-4 h-4 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span className="text-white/80 text-sm font-medium">Transaction Path</span>
                </div>
                <div className="space-y-1">
                  {transactionPath.map((step, index) => (
                    <div key={index} className="flex items-center gap-2 text-white/70 text-xs">
                      <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                      <span>{step}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Buttons */}
            <div className="mb-4 mt-6 flex gap-2">
  {/* Lock Button */}
  {signer === null ? 
   <button
   //onClick={initializeProvider}
   className={`px-4 py-2 w-full bg-white/5 border text-white hover:bg-white/10 border-white/10 rounded-sm font-semibold transition duration-300`}
  >
   Connect
  </button>
  :
  <>
  <button
    onClick={handleLockVista}
    disabled={!tokenAmount || tokenAmount <= 0}
    className={`flex-1 text-[16px] font-semibold bg-green-400/10 hover:bg-green-400/15 border border-green-400/40 hover:border-green-400/50 text-gray-300 hover:text-gray-100 rounded-sm transition duration-100 py-2 px-4 disabled:opacity-50 disabled:cursor-not-allowed`}
  >
    Lock
  </button>
  <button
    onClick={handleUnlockVista}
    disabled={!tokenAmount || tokenAmount <= 0}
    className={`flex-1 text-[16px] font-semibold bg-red-400/10 hover:bg-red-400/15 border border-red-400/40 hover:border-red-400/50 text-gray-300 hover:text-gray-100 rounded-sm transition duration-100 py-2 px-4 disabled:opacity-50 disabled:cursor-not-allowed`}
  >
    Unlock
  </button>
  <button
    onClick={() => handleClaimRewards('0xfdd05552F1377aA488AFed744c8024358AF02041')}
    className={`flex-1 text-[16px] font-semibold bg-yellow-400/10 hover:bg-yellow-400/15 border border-yellow-400/40 hover:border-yellow-400/50 text-gray-300 hover:text-gray-100 rounded-sm transition duration-100 py-2 px-4`}
  >
    Claim
  </button>
  </>
  }
</div>

          </div>
        );
      case 'hardlock':
        return (
          <div>
                  {/* Input Field */}
      <div className="mb-4">
        <input
          type="text"
          placeholder="Select Token Pair" 
          onClick={() => setIsPopupOpen(true)}
          value={selectedToken ? "Pair Address: " + pairAddress.slice(0,5)+'...'+pairAddress.slice(-5) : ''}
          readOnly
          className="w-full p-2 border border-gray-600 rounded-md cursor-pointer bg-white/5 hover:bg-white/10 text-gray-400 placeholder-gray-400"
        />
      </div>
            {/* Popup */}
            {isPopupOpen && (
                    <>
                      {/* Overlay */}
                      <div
                        className="fixed inset-0 bg-black/70 bg-opacity-75 flex items-center justify-center z-[9994]"
                        onClick={() => setIsPopupOpen(false)}
                      ></div>

                      {/* Modal Content */}
                      <div className="fixed inset-0 flex items-center justify-center z-[9999]">
                        <div className="bg-[#0e1018] p-6 rounded-md shadow-md w-80 relative">
                          <h3 className="text-xl font-semibold mb-4 text-white">Select a Token</h3>
                          <ul className="mb-4 h-64 overflow-y-auto no-scrollbar">
                            {featuredTokens.map((token) => (
                                <li key={token.address} className="mb-2">
                                <button
                                    onClick={() => handleTokenSelect(token)}
                                    className="w-full text-left p-2 flex justify-between bg-white/5 border border-white/10 hover:bg-gray-600 rounded-md text-white"
                                >
                                    {token.name}
                                    <img src={token.logo} className="w-auto h-6" alt="featured token" />
                                </button>
                                </li>
                            ))}
                            </ul>

                          <div className="flex mb-4">
                            <input
                              type="text"
                              placeholder="Paste token pair"
                              value={pairAddress}
                              onChange={(e) => setPairAddress(e.target.value)}
                              className="flex-1 p-2 border-t border-b text-[15px]  border-white/15 text-gray-300 rounded-md bg-transparent focus:outline-none"
                            />
                            <button
                              onClick={handleAddressInput}
                              className="p-2 bg-white/5 hover:bg-white/10 text-white rounded-r-md text-sm"
                            >
                              Select
                            </button>
                          </div>
                          <button
                            onClick={() => setIsPopupOpen(false)}
                            className="absolute top-2 right-2 text-gray-400 hover:text-gray-200"
                          >
                            ✕
                          </button>
                        </div>
                      </div>
                    </>
                  )}

            {/* Input for Token Amount */}
            <div className="mb-4">
              <label htmlFor="othertokenAmountHardlock" className="block text-gray-300 mt-8">
                Enter Amount of LP Tokens to Hardlock:
              </label>
              <input
                type="number"
                id="othertokenAmountHardlock"
                value={othertokenAmount}
                onWheel={e => e.target.blur()}  
                onChange={(e) => setothertokenAmount(e.target.value)}
                placeholder="Token Amount"
                className="w-full py-3 px-2 mt-2 border-t border-b text-[15px]  border-white/15 text-gray-300 rounded-md bg-transparent focus:outline-none"
                min="0"
              />
            </div>

            {/* Labels */}
            {selectedToken && <div className="mb-4 text-gray-300">
              <p className="flex justify-between mb-2">
                    <p>Your Pair LP Balance: </p> <span>{pairLPBalance}</span>
                  </p>
              <p className="flex justify-between mb-2">
                    <p>Your Rewards:</p> <span>${rewardsStats[0]}</span>
                  </p>

                  {/*<p className="flex justify-between mb-2">
                    <p>Yearly Rewards:</p> <span>${rewardsStats[1]}</span>
              </p>*/}
              <p className="flex justify-between">
                <p>Current Pool:</p> <span>${rewardsStats[2]}</span>
              </p>
            </div>}

            {/* Warning */}
            <div className="mb-4 p-2 bg-white/10 border-l-4 border-white-500 text-white-700">
              <p>
                Warning: Hardlocking your non-VISTA LP tokens is permanent. However, the tokens will continue to generate ETH rewards forever, making it suitable for creators focused on long-term strategies.
              </p>
            </div>

            {/* Transaction Path Indicator */}
            {signer && (
              <div className="mt-4 mb-2 p-3 bg-white/5 border border-white/10 rounded-lg">
                <div className="flex items-center gap-2 mb-2">
                  <svg className="w-4 h-4 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span className="text-white/80 text-sm font-medium">Transaction Path</span>
                </div>
                <div className="space-y-1">
                  {transactionPath.map((step, index) => (
                    <div key={index} className="flex items-center gap-2 text-white/70 text-xs">
                      <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                      <span>{step}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Buttons */}
            <div className="mb-4  flex">
 {signer !== null ? <>
 {/* Hardlock Button */}
 <button
    onClick={handleLockToken}
    disabled={othertokenAmount <= 0 || !pairAddress}
    className={`${
      othertokenAmount <= 0 || !selectedToken
        ? 'text-white/50 '
        : 'text-white hover:bg-white/10'
    } px-4 py-2 w-full mr-2 bg-white/5 border border-white/10 rounded-md font-semibold transition duration-300`}
  >
    Hardlock
  </button>

  {/* Claim Rewards Button */}
  <button
    onClick={() => handleClaimRewards(pairAddress)}
    disabled={rewardsStats[0] <= 0 || rewardsStats[0] === null || !pairAddress}
    className={`${
      (rewardsStats[0] <= 0 || rewardsStats[0] === null || !pairAddress)
        ? 'text-white/50 bg-gray-500/20 border border-gray-500/30'
        : 'text-white hover:bg-yellow-300/40 bg-yellow-300/20 border border-yellow-300/50 shadow-[0_0_15px_5px_rgba(253,224,71,0.2)]'
    } px-4 py-2 w-full rounded-md font-semibold transition duration-300`}
  >
    Claim Rewards
  </button>

 </>:
 <button
 //onClick={initializeProvider}
 className={` px-4 py-2 w-full mr-2 bg-white/5 border text-white hover:bg-white/10 border-white/10 rounded-md font-semibold transition duration-300`}
>
 Connect
</button>
 }
  
  {/* Note: Unstake button is removed */}
</div>
          </div>
        );
      
      default:
        return null;
    }
  };

  return (
    <div className="w-full min-h-[80vh] flex flex-col items-center justify-center px-4 sm:px-0">
      <div className="w-full max-w-[700px] bg-gradient-to-b from-[#ffffff09] to-[#ffffff05] border border-white/10 rounded-2xl shadow-xl px-6 sm:px-10 py-6 flex flex-col gap-6 relative mt-24 mb-8 transition-shadow duration-300">
        {/* Header */}
        <div className="flex flex-col items-center justify-center w-full mb-2">
          {activeTab === 'vista' ? (
            <img src="/ethervista.png" alt="Vista Logo" className="w-10 h-10 rounded-full border-2 border-white/10 mb-2" />
          ) : (
            <img src={require('../../assets/etherfun.png')} alt="Etherfun Logo" className="w-10 h-10 rounded-full border-2 border-white/10 mb-2" />
          )}
          <h2 className="text-2xl sm:text-3xl font-bold text-white tracking-tight kanit-light text-center">Hardlock LP</h2>
        </div>
        <div className="text-white/70 text-base sm:text-lg text-center max-w-xl mb-2">Securely lock your liquidity while continuing to earn ETH rewards</div>
        {/* Tab Bar */}
        <div className="flex justify-center mt-2 mb-4 w-full max-w-[700px] mx-auto">
          <div className="flex bg-white/5 rounded-full shadow border border-white/10 px-2 py-1 gap-2 w-full justify-center">
            {chain === "ethereum" && <button
              onClick={() => setActiveTab('vista')}
              className={`flex items-center gap-2 px-6 py-2 rounded-full text-[15px] font-semibold transition-all duration-150
                ${activeTab === 'vista' ? 'bg-green-400/10 text-gray-300 border-green-400/40 border' : 'text-white/60 bg-white/0 border border-white/10 hover:bg-green-400/10 hover:border-green-400/40'}
            `}
            >
              VISTA
            </button>}
            <button
              onClick={() => setActiveTab('hardlock')}
              className={`flex items-center gap-2 px-6 py-2 rounded-full text-[15px] font-semibold transition-all duration-150
                ${activeTab === 'hardlock' ? 'bg-yellow-400/10 text-gray-300 border-yellow-400/40 border' : 'text-white/60 bg-white/0 border border-white/10 hover:bg-yellow-400/10 hover:border-yellow-400/40'}
              `}
            >
              Other Tokens
            </button>
          </div>
        </div>
        {/* Tab Content */}
        <div className="w-full">
          {activeTab === 'vista' && (
            <>
              {/* Stats Grid */}
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 w-full mb-4">
                <div className="rounded-xl bg-gradient-to-b from-[#23283a] to-[#181c24] border border-white/10 p-3 flex flex-col items-center">
                  <span className="text-white/70 text-xs">Locked Amount</span>
                  <span className="text-base sm:text-xl font-bold text-white mt-1">{tokenLockInfo.amount}</span>
                </div>
                <div className="rounded-xl bg-gradient-to-b from-[#23283a] to-[#181c24] border border-white/10 p-3 flex flex-col items-center">
                  <span className="text-white/70 text-xs">Lock Time</span>
                  <span className="text-base sm:text-xl font-bold text-white mt-1">14 days</span>
                </div>
                <div className="rounded-xl bg-gradient-to-b from-[#23283a] to-[#181c24] border border-white/10 p-3 flex flex-col items-center col-span-2 sm:col-span-1">
                  <span className="text-white/70 text-xs">Time Left</span>
                  <span className="text-base sm:text-xl font-bold text-white mt-1">{tokenLockInfo.timeLeftFormatted}</span>
                </div>
              </div>
              {/* Rewards Grid */}
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 w-full mb-4">
                <div className="rounded-xl bg-gradient-to-b from-[#23283a] to-[#181c24] border border-white/10 p-3 flex flex-col items-center">
                  <span className="text-yellow-200 text-xs">Your Rewards</span>
                  <span className="text-base sm:text-lg font-bold text-yellow-200 mt-1">${rewardsStatsVista[0]}</span>
                </div>
                <div className="rounded-xl bg-gradient-to-b from-[#23283a] to-[#181c24] border border-white/10 p-3 flex flex-col items-center">
                  <span className="text-yellow-100 text-xs">Yearly Rewards</span>
                  <span className="text-base sm:text-lg font-bold text-yellow-100 mt-1">${rewardsStatsVista[1]}</span>
                </div>
                <div className="rounded-xl bg-gradient-to-b from-[#23283a] to-[#181c24] border border-white/10 p-3 flex flex-col items-center col-span-2 sm:col-span-1">
                  <span className="text-blue-200 text-xs">Claimable Rewards</span>
                  <span className="text-base sm:text-lg font-bold text-blue-200 mt-1">${rewardsStatsVista[2]}</span>
                </div>
              </div>

              {/* Input + Actions */}
              <div className="flex flex-col gap-2 w-full mt-4">
                <label htmlFor="tokenAmount" className="block text-white/80 text-[15px] font-semibold mb-1 text-left">Amount</label>
                <div className="relative w-full">
                  <input
                    type="number"
                    id="tokenAmount"
                    value={tokenAmount}
                    onWheel={e => e.target.blur()}  
                    onChange={(e) => setTokenAmount(e.target.value)}
                    placeholder="Lp Token Amount"
                    className="w-full p-3 pr-28 text-[15px] border border-white/15 text-gray-300 rounded-lg bg-[#181c24] focus:outline-none focus:ring-2 focus:ring-yellow-300/40 transition"
                    min="0"
                  />
                  <div className="absolute inset-y-0 right-2 flex items-center gap-1">
                    <button
                      disabled={!vistaLPBalance || Number(vistaLPBalance) <= 0}
                      onClick={() => setTokenAmount(((Number(vistaLPBalance)||0)*0.25).toFixed(18))}
                      className={`px-2 py-0.5 text-[11px] rounded bg-white/5 border border-white/10 hover:bg-white/10 ${(!vistaLPBalance || Number(vistaLPBalance)<=0) ? 'opacity-40 cursor-not-allowed' : 'text-white/80'}`}
                    >
                      25%
                    </button>
                    <button
                      disabled={!vistaLPBalance || Number(vistaLPBalance) <= 0}
                      onClick={() => setTokenAmount(((Number(vistaLPBalance)||0)*0.5).toFixed(18))}
                      className={`px-2 py-0.5 text-[11px] rounded bg-white/5 border border-white/10 hover:bg-white/10 ${(!vistaLPBalance || Number(vistaLPBalance)<=0) ? 'opacity-40 cursor-not-allowed' : 'text-white/80'}`}
                    >
                      50%
                    </button>
                    <button
                      disabled={!vistaLPBalance || Number(vistaLPBalance) <= 0}
                      onClick={() => setTokenAmount((Number(vistaLPBalance)||0).toFixed(18))}
                      className={`px-2 py-0.5 text-[11px] rounded bg-white/5 border border-white/10 hover:bg-white/10 ${(!vistaLPBalance || Number(vistaLPBalance)<=0) ? 'opacity-40 cursor-not-allowed' : 'text-white/90'}`}
                    >
                      MAX
                    </button>
                  </div>
                </div>
                <div className="flex flex-row gap-1 sm:gap-2 w-full mt-3">
                  {signer !== null ? <>
                    <button
                      onClick={handleLockVista}
                      disabled={!tokenAmount || tokenAmount <= 0}
                      className="flex-1 text-[12px] sm:text-[16px] font-semibold bg-green-400/10 hover:bg-green-400/15 border border-green-400/40 hover:border-green-400/50 text-gray-300 hover:text-gray-100 rounded-sm transition duration-100 py-1.5 sm:py-2 px-2 sm:px-4 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      Lock
                    </button>
                    <button
                      onClick={handleUnlockVista}
                      disabled={!tokenAmount || tokenAmount <= 0}
                      className="flex-1 text-[12px] sm:text-[16px] font-semibold bg-red-400/10 hover:bg-red-400/15 border border-red-400/40 hover:border-red-400/50 text-gray-300 hover:text-gray-100 rounded-sm transition duration-100 py-1.5 sm:py-2 px-2 sm:px-4 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      Unlock
                    </button>
                  </>:
                    <button
                      className="flex-1 text-[12px] sm:text-[16px] font-semibold bg-white/5 border border-white/10 rounded-sm shadow hover:bg-white/10 hover:border-white/20 transition duration-200 py-1.5 sm:py-2 px-2 sm:px-4"
                    >
                      Connect
                    </button>
                  }
                  <button
                    onClick={() => handleClaimRewards('0xfdd05552F1377aA488AFed744c8024358AF02041')}
                    className="flex-1 text-[12px] sm:text-[16px] font-semibold bg-yellow-400/10 hover:bg-yellow-400/15 border border-yellow-400/40 hover:border-yellow-400/50 text-gray-300 hover:text-gray-100 rounded-sm transition duration-100 py-1.5 sm:py-2 px-2 sm:px-4"
                  >
                    Claim
                  </button>
                </div>
              </div>

              {/* Transaction Path Indicator */}
              {signer && (
                <div className="mt-4 mb-2 p-3 bg-white/5 border border-white/10 rounded-lg">
                  <div className="flex items-center gap-2 mb-2">
                    <svg className="w-4 h-4 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span className="text-white/80 text-sm font-medium">Transaction Path</span>
                  </div>
                  <div className="space-y-1">
                    {transactionPath.map((step, index) => (
                      <div key={index} className="flex items-center gap-2 text-white/70 text-xs">
                        <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                        <span>{step}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
          {activeTab === 'hardlock' && (
            <>
              {/* Token Pair Selector */}
              <div className="mb-4">
                <input
                  type="text"
                  placeholder="Select Token Pair" 
                  onClick={() => setIsPopupOpen(true)}
                  value={selectedToken ? "Pair Address: " + pairAddress.slice(0,5)+'...'+pairAddress.slice(-5) : ''}
                  readOnly
                  className="w-full p-3 border border-gray-600 rounded-lg cursor-pointer bg-white/5 hover:bg-white/10 text-gray-400 placeholder-gray-400"
                />
              </div>
              {/* Popup */}
              {isPopupOpen && (
                <>
                  <div
                    className="fixed inset-0 bg-black/70 bg-opacity-75 flex items-center justify-center z-[9994]"
                    onClick={() => setIsPopupOpen(false)}
                  ></div>
                  <div className="fixed inset-0 flex items-center justify-center z-[9999]">
                    <div className="bg-[#0e1018] p-6 rounded-xl shadow-md w-80 relative border border-white/10">
                      <h3 className="text-xl font-semibold mb-4 text-white">Select a Token</h3>
                      <ul className="mb-4 h-64 overflow-y-auto no-scrollbar">
                        {featuredTokens.map((token) => (
                          <li key={token.address} className="mb-2">
                            <button
                              onClick={() => handleTokenSelect(token)}
                              className="w-full text-left p-2 flex justify-between bg-white/5 border border-white/10 hover:bg-gray-600 rounded-lg text-white"
                            >
                              {token.name}
                              <img src={token.logo} className="w-auto h-6" alt="featured token" />
                            </button>
                          </li>
                        ))}
                      </ul>
                      <div className="flex mb-4">
                        <input
                          type="text"
                          placeholder="Paste token pair"
                          value={pairAddress}
                          onChange={(e) => setPairAddress(e.target.value)}
                          className="flex-1 p-2 border-t border-b text-[15px] border-white/15 text-gray-300 rounded-lg bg-transparent focus:outline-none"
                        />
                        <button
                          onClick={handleAddressInput}
                          className="p-2 bg-white/5 hover:bg-white/10 text-white rounded-r-lg text-sm"
                        >
                          Select
                        </button>
                      </div>
                      <button
                        onClick={() => setIsPopupOpen(false)}
                        className="absolute top-2 right-2 text-gray-400 hover:text-gray-200"
                      >
                        ✕
                      </button>
                    </div>
                  </div>
                </>
              )}
              {/* Stats Grid */}
              {selectedToken && (
                <div className="grid grid-cols-2 gap-3 w-full mb-4 justify-center items-center">
                  <div className="rounded-xl bg-gradient-to-b from-[#23283a] to-[#181c24] border border-white/10 p-3 flex flex-col items-center w-full">
                    <span className="text-white/70 text-xs">Your Pair LP Balance</span>
                    <span className="text-base sm:text-2xl font-bold text-white mt-1">{pairLPBalance}</span>
                  </div>
                  <div className="rounded-xl bg-gradient-to-b from-[#23283a] to-[#181c24] border border-white/10 p-3 flex flex-col items-center w-full">
                    <span className="text-yellow-200 text-xs">Your Rewards</span>
                    <span className="text-base sm:text-xl font-bold text-yellow-200 mt-1">${rewardsStats[0]}</span>
                  </div>
                </div>
              )}

              {/* Input + Actions */}
              <div className="flex flex-col gap-2 w-full mt-4">
                <label htmlFor="othertokenAmountHardlock" className="block text-white/80 text-[15px] font-semibold mb-1 text-left">Amount</label>
                <div className="relative w-full">
                  <input
                    type="number"
                    id="othertokenAmountHardlock"
                    value={othertokenAmount}
                    onWheel={e => e.target.blur()}  
                    onChange={(e) => setothertokenAmount(e.target.value)}
                    placeholder="Lp Token Amount"
                    className="w-full p-3 pr-28 text-[15px] border border-white/15 text-gray-300 rounded-lg bg-[#181c24] focus:outline-none focus:ring-2 focus:ring-yellow-300/40 transition"
                    min="0"
                  />
                  <div className="absolute inset-y-0 right-2 flex items-center gap-1">
                    <button
                      disabled={!pairLPBalance || Number(pairLPBalance) <= 0}
                      onClick={() => setothertokenAmount(((Number(pairLPBalance)||0)*0.25).toFixed(18))}
                      className={`px-2 py-0.5 text-[11px] rounded bg-white/5 border border-white/10 hover:bg-white/10 ${(!pairLPBalance || Number(pairLPBalance)<=0) ? 'opacity-40 cursor-not-allowed' : 'text-white/80'}`}
                    >
                      25%
                    </button>
                    <button
                      disabled={!pairLPBalance || Number(pairLPBalance) <= 0}
                      onClick={() => setothertokenAmount(((Number(pairLPBalance)||0)*0.5).toFixed(18))}
                      className={`px-2 py-0.5 text-[11px] rounded bg-white/5 border border-white/10 hover:bg-white/10 ${(!pairLPBalance || Number(pairLPBalance)<=0) ? 'opacity-40 cursor-not-allowed' : 'text-white/80'}`}
                    >
                      50%
                    </button>
                    <button
                      disabled={!pairLPBalance || Number(pairLPBalance) <= 0}
                      onClick={() => setothertokenAmount((Number(pairLPBalance)||0).toFixed(18))}
                      className={`px-2 py-0.5 text-[11px] rounded bg-white/5 border border-white/10 hover:bg-white/10 ${(!pairLPBalance || Number(pairLPBalance)<=0) ? 'opacity-40 cursor-not-allowed' : 'text-white/90'}`}
                    >
                      MAX
                    </button>
                  </div>
                </div>
                <div className="flex flex-row gap-1 sm:gap-2 w-full mt-3">
                  {signer !== null ? <>
                    <button
                      onClick={handleLockToken}
                      disabled={othertokenAmount <= 0 || !pairAddress}
                      className="flex-1 text-[12px] sm:text-[16px] font-semibold bg-green-400/10 hover:bg-green-400/15 border border-green-400/40 hover:border-green-400/50 text-gray-300 hover:text-gray-100 rounded-sm transition duration-100 py-1.5 sm:py-2 px-2 sm:px-4 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      Hardlock
                    </button>
                  </>:
                    <button
                      className="flex-1 text-[12px] sm:text-[16px] font-semibold bg-white/5 border border-white/10 rounded-sm shadow hover:bg-white/10 hover:border-white/20 transition duration-200 py-1.5 sm:py-2 px-2 sm:px-4"
                    >
                      Connect
                    </button>
                  }
                  <button
                    onClick={() => handleClaimRewards(pairAddress)}
                    disabled={rewardsStats[0] <= 0 || rewardsStats[0] === null || !pairAddress}
                    className="flex-1 text-[12px] sm:text-[16px] font-semibold bg-yellow-400/10 hover:bg-yellow-400/15 border border-yellow-400/40 hover:border-yellow-400/50 text-gray-300 hover:text-gray-100 rounded-sm transition duration-100 py-1.5 sm:py-2 px-2 sm:px-4"
                  >
                    Claim
                  </button>
                </div>
              </div>

              {/* Transaction Path Indicator */}
              {signer && (
                <div className="mt-4 mb-2 p-3 bg-white/5 border border-white/10 rounded-lg">
                  <div className="flex items-center gap-2 mb-2">
                    <svg className="w-4 h-4 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span className="text-white/80 text-sm font-medium">Transaction Path</span>
                  </div>
                  <div className="space-y-1">
                    {transactionPath.map((step, index) => (
                      <div key={index} className="flex items-center gap-2 text-white/70 text-xs">
                        <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                        <span>{step}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      {/* Warning */}
      <div className="mb-6 w-full max-w-[700px] flex items-center gap-3 px-5 py-4 bg-yellow-400/10 border-l-4 border-yellow-300 rounded-xl text-yellow-200 shadow mt-2">
        <svg className="w-6 h-6 text-yellow-300" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M12 9v2m0 4h.01M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z"/></svg>
        <span className="text-yellow-100 font-medium">Please claim any rewards before locking/unlocking, or the rewards will be lost. Hardlocking non-VISTA LPs is permanent.</span>
      </div>
    </div>
  );
}
